import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "../lib/Axios";

export default function AccountLogout() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Logout"; }, []);

	var navigate = useNavigate();
	var [state, setState] = useState("Logging Out...");
	var [searchParams] = useSearchParams();
	var [all] = useState(searchParams.has("all"));
    var [query] = useState("?" + searchParams);

	useEffect(() => {

		axios.post("/user/logout", new URLSearchParams(all && { all })).then(({ data }) => {
			if (data.state === true) {
				_.user = false; //Remove user info from global context.
				navigate("/account/login" + query);
			} else {
				setState("An error occured while trying to logout. Try again later.");
			}
		}).catch(e => {
			setState("An error occured while trying to logout. Try again later.");
			console.error(e);
        });
	}, [navigate]);
	
	return <Section center>
		<p>{state}</p>
	</Section>;
}